import { makeStyles } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import SearchIcon from "@material-ui/icons/Search";
import React, { useEffect, useState } from "react";
import { getUsers } from "../../apis/users";
import { CreateUserForm } from './CreateUserForm';



import { blue } from "@material-ui/core/colors";
import useStyles from "../muistyles";
import { LightTooltip } from "../../components/LightTooltip";
import { TextInput,AddButton,UpdateButton,DeleteButton,SelectInput} from "../GenericReusableComponents/HTMLWrappers";
import {Table} from "../GenericReusableComponents/Table"
import { ConfirmDialog } from "../GenericReusableComponents/ConfirmDialog";
import { FormDialog } from "../GenericReusableComponents/FormDialog";
import {deleteUser} from "../../apis/users"
import { updateUser,getUserGroups,createUser } from "../../apis/users";


export default function UserMgmt() {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [userGroups, setUserGroups] = useState([]);
  const [q, setQ] = useState("");
  const [showAddUserForm,setShowAddUserForm] = useState(false);
  const [showDelUserModal,setShowDelUserModal] = useState(false);
  const [showUpdtUserModal,setShowUpdtUserModal] = useState(false);
  const [userTobeDel,setUserTobeDel] = useState({});
  const [user,setUser] = useState({});
  const [usersChanged,setUsersChanged] = useState(false);
  const [deleteConfirmMessage,setDeleteConfirmMessage] = useState("");
  
  const classes = useStyles();


  useEffect(() => {
    console.log("Inside useEffect Usrmgmt");
    let mounted = true;
    if(users.length && !usersChanged){
      console.log("usersChanged :"+usersChanged)
      return;
    }
    getUserGroups().then((ug) => {
      console.log("display userGroups");
      console.log(ug);

      if (mounted) {

        let vl = ug.map(i => {
          return {value:i, label:i}
        })
        setUserGroups(vl);
      }
    });

    getUsers().then((data) => {
      console.log("display Users");
      console.log(data);
      console.log(typeof data);

      if (mounted) {
        setUsers(data.Users);
        var fusers = [];
        users.forEach((x) => fusers.push(x));
        setFilteredUsers(fusers);
        setUsersChanged(false);
      }
    });
    return () => {console.log("UserMgmt is unmounted"); mounted = false};
  }, [usersChanged]);

  function filterTable(filterString) {
    console.log(filterString);
    let trimStr = filterString.trim();
    if (trimStr === "") {
      setFilteredUsers(users);
      setQ("");
    } else {
      setQ(filterString);
      setFilteredUsers(
        users.filter((user) => {
          if (user.userName.startsWith(filterString)) return true;

          if (user.fullName.startsWith(filterString)) return true;

          if (user.phone.startsWith(filterString)) return true;

          if (user.userGroup.startsWith(filterString)) return true;

          if (user.status.startsWith(filterString)) return true;

          console.log("no match ");
          console.dir(user);
        })
      );
    }
  }

  function setUsersChangedTrigger(bool){
    console.log("setUsersChanged "+bool)
    setUsersChanged(bool);
  }

  function addUser(){
    console.log("addUser");
    setShowAddUserForm(true);
  }

  function onClickDeletUser(e,user){
    console.log("deleteUser");
    console.dir(user.userName);
    let message = `Confirm if you to want to delete User: ${user.userName}`;
    setDeleteConfirmMessage(message);
    setUserTobeDel(user);
    setShowDelUserModal(true);
  }

  function handleDeleteUser(){
      deleteUser(userTobeDel);
      setUsersChanged(true);
  }

  function onClickUpdateUser(e,user){
    console.log("updateUser");
    console.dir(user.userName);
    setUser(user);
    setShowUpdtUserModal(true);

  }

  function setShow(bool){
    setShowAddUserForm(bool);
  }

  function setShowDel(bool){
    setShowDelUserModal(bool);
  }

  function setShowUpdt(bool){
    setShowUpdtUserModal(bool);
  }


  function getTableActions() {
    return (
      <>
        <LightTooltip title="Create New User">
          <Button
            variant="contained"
            color="primary"
            onClick={addUser}
            className={classes.button}
            startIcon={<PersonAddIcon fontSize="inherit" />}
          >
            Add User
          </Button>
        </LightTooltip>
    

      </>
    );
  }
  //temporarily duplicating the code. reuse later
  function getStatusStyle(status){
    var statusStyle = "status";
    switch (status){
      case "INACTIVE":
        statusStyle = statusStyle + " statusInactive";
        break;
      case "DISABLED":
        statusStyle = statusStyle + " statusDisabled";
        break;

      default: statusStyle = statusStyle + " statusActive"
    }
    return statusStyle;
  }


  const tableColumns = [
    "User Name", 
    "Full Name",
    "Phone",
    "User Group",
    "Status",
    "Actions",
  ]

  function getTableHeader(){
    return(
      tableColumns.map(i =>(
        <th>{i}</th>
      ))
    )
  }

  function getTableBody(){
    return(filteredUsers.map((user) => (
      <tr>
        <td>{user.userName}</td>
        <td>{user.fullName}</td>
        <td>{user.phone}</td>
        <td>{user.userGroup}</td>
        <td><span className={getStatusStyle(user.status)}>{user.status}</span></td>
        <td>
          <LightTooltip title="Edit User">
          <IconButton onClick={(e)=>onClickUpdateUser(e,user)}>
            <EditIcon></EditIcon>
          </IconButton>
          </LightTooltip>
          <LightTooltip title="Delete User">
          <IconButton onClick={(e)=>onClickDeletUser(e,user)}>
            <DeleteIcon></DeleteIcon>
          </IconButton>
          </LightTooltip>
        </td>
      </tr>
    ))

    )
  }

  function onChangeHandler(e){
    let luser = {...user};
    if(e.target.name === 'User Name'){
      luser.userName = e.target.value;
    }

    if(e.target.name === 'Full Name'){
      luser.fullName = e.target.value;
    }

    if(e.target.name === 'Phone'){
      luser.phone = e.target.value;
    }

    if(e.target.name === 'User Group'){
      luser.userGroup = e.target.value;
    }



    setUser(luser);

  }
  function getFormElements(){
    return(
    <>
      <TextInput tname="User Name" 
          tplaceholder = "Enter User Name"
          tvalue = {user.userName}
          tHandleOnChange={e => onChangeHandler(e)} />

      <TextInput tname="Full Name" 
          tplaceholder = "Enter Full Name"
          tvalue = {user.fullName}
          tHandleOnChange={e => onChangeHandler(e)} />
      
      
      <TextInput tname="Phone" 
          tplaceholder = "Enter Phone Number"
          tvalue = {user.phone}
          tHandleOnChange={e => onChangeHandler(e)} />
      
      <SelectInput 
        sname="User Group" 
        svalueList={userGroups} 
        svalue={user.userGroup} 
        onChangeHandler={e => onChangeHandler(e)}/>
     
    </>
    )
  }

  function formSubmitUpdate(){
    updateUser(user);
    setUsersChanged(true);
  }

  function formSubmitAdd(){
    createUser(user);
    setUsersChanged(true);
  }


  return (
    <>
 
        <Table 
          search={filterTable} 
          tableActions={getTableActions()} 
          columns={getTableHeader()} 
          rows={getTableBody()}
          />
        
        <FormDialog 
          showDialog={showAddUserForm} 
          setShowDialog={setShow} 
          formHeader="Add User" 
          formElements= {getFormElements()} 
          submitButtonMessage="Add User" 
          onFormSubmit={formSubmitAdd}/>
        
        <FormDialog 
          showDialog={showUpdtUserModal} 
          setShowDialog={setShowUpdt} 
          formHeader="Update User" 
          formElements= {getFormElements()} 
          submitButtonMessage="Update User" 
          onFormSubmit={formSubmitUpdate}/>

        <ConfirmDialog 
          showConfirmDialog={showDelUserModal} 
          setShowConfirmDialog={setShowDel} 
          confirmMessage={deleteConfirmMessage}
          onConfirm={handleDeleteUser}/>
       
    </>
  );
}
